import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import { Clipboard } from 'ts-clipboard';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../../app.common/modules/common/services/popup.service';
import { OrderSettingsService } from '../../order-settings.service';

class FoodMonitorUrlGenerator implements ng.IController {
    public static inject = ['$translate', '$location', 'orderSettingsService', 'notificationService'];

    public onKeyChanged: (monitorState: any) => any;
    public isEnabled: boolean;
    public url: string;
    public key: string;
    public hideMonitor: boolean = false;

    constructor(
        private $translate: ng.translate.ITranslateService,
        private $location: ng.ILocationService,
        private orderSettingsService: OrderSettingsService,
        private notificationService: NotificationService,
        private popupService: PopupService
    ) {}

    public $onInit(): void {
        if (this.key) {
            this.url = this.createFullUrl(this.key, this.hideMonitor);
        }
    }

    public copyUrlToClipBoard() {
        Clipboard.copy(this.url);
        this.notificationService.showInfoMessage({
            title: this.$translate.instant('info'),
            body: this.$translate.instant('food_monitor_url_copy_message')
        });
        this.notificationService.clearAll();
    }

    public async generateNewUrl() {
        try {
            this.key = await this.orderSettingsService.generateMonitorKey();
            this.url = this.createFullUrl(this.key, this.hideMonitor);
            this.sendChangeEnable();
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
    }

    public addOrDeleteHideParam() {
        this.url = this.createFullUrl(this.key, this.hideMonitor);
        this.sendChangeEnable();
    }

    public async changeMonitorEnable($event: Event) {

        $event.preventDefault();
        $event.stopPropagation();

        if (!this.key) {
            await this.generateNewUrl();
        }

        if (!this.isEnabled) {
            this.isEnabled = true;
            this.sendChangeEnable();
            return ;
        }

        if (this.isEnabled) {
            try {
                await this.popupService.confirm({
                    okClass: 'btn-new btn-new-cancel',
                    okTxt: this.$translate.instant('food_monitor_disable_dialog_cancel'),
                    cancelClass: 'btn-new btn-new-disable',
                    cancelTxt: this.$translate.instant('food_monitor_disable_dialog_ok'),
                    classPopup: 'popup--redesign modal360',
                    title: this.$translate.instant('food_monitor_disable_dialog_title'),
                    content: this.$translate.instant('food_monitor_disable_dialog_content'),
                    invertAction: true
                });
            } catch (e) {
                return;
            }
        }

        this.isEnabled = false;
        this.sendChangeEnable();
    }

    private sendChangeEnable() {
        const monitor = { isEnabled: this.isEnabled, key: this.key, hideMonitor: this.hideMonitor };
        this.onKeyChanged({ monitorState: monitor });
    }

    private createFullUrl(monitorKey: string, addHideMonitorParam: boolean): string {
        const protocol = location.protocol === 'https:' ? 'https://' : 'http://';
        const hostName = location.host;
        return `${protocol}${hostName}/fm?key=${monitorKey}${addHideMonitorParam ? '&hideBody=1' : ''}`;
    }

}

angular.module('naut').component('foodMonitorUrlGenerator', {
    template: require('./food-monitor-url-generator.component.html'),
    controller: FoodMonitorUrlGenerator,
    controllerAs: 'ctrl',
    bindings: {
        editMode: '<',
        key: '<',
        hideMonitor: '<',
        isEnabled: '<',
        onKeyChanged: '&'
    }
});



// WEBPACK FOOTER //
// ./src/app.retailer/modules/tapAndGo/components/food-monitor-url-generator/food-monitor-url-generator.component.ts